// extracted by mini-css-extract-plugin
export var wrapper = "Navigation-module--wrapper--56rr2";
export var primaryMenuList = "Navigation-module--primary-menu-list--2-RXP";
export var primaryMenuItem = "Navigation-module--primary-menu-item--dxzi4";
export var moreButton = "Navigation-module--more-button--2oMIt";
export var opened = "Navigation-module--opened--S5tXL";
export var subMenuWrapper = "Navigation-module--sub-menu-wrapper--GQ5jb";
export var subMenuList = "Navigation-module--sub-menu-list--2V1is";
export var subMenuItem = "Navigation-module--sub-menu-item--nmq59";
export var subMenuTitle = "Navigation-module--sub-menu-title--27sX6";